import HttpAPI from '../../providers/httpService';
import ApiConfig from '../../app_config/apiConfig';
import {GET_CONFIGURATION_DATA, PAGE_LEVEL_REFINER, GET_TERM_STORE} from '../../constants/reducerTypes';
import ConfigModel from '../../apiModels/configModel';
import FetchRefinerModel from '../../apiModels/fetchRefinerModel';


const initConfigurationData = () => dispatch => {
  HttpAPI.requestApi([
    {
      api: ApiConfig.endpointConfig.configurationData
    },
    {
      api: ApiConfig.endpointConfig.getHierarchicalRefinerValues
    },
    {
      api: ApiConfig.endpointConfig.isValidEYP
    }
  ]).then(
    (data) => {
      /**
      * navigation items array creation.
      *
      */
      const [, , isValidEYP] = data;
      let pageConfig = {};
      let termStoreData = {};
      if (data[0] && data[0].ok !== false) {
        const dataConfigurationModel = new ConfigModel(data[0]);
        if (dataConfigurationModel.getPageConfiguration().length > 0) {
          pageConfig = dataConfigurationModel.getConfigData();
        }
      }
      pageConfig.isEYPValidUser = isValidEYP.ok !== false ? isValidEYP : false;

      if (data[1] && data[1].ok !== false) {
        [, termStoreData,] = data;
      }

      dispatch({
        type: GET_CONFIGURATION_DATA,
        payload: pageConfig
      });

      dispatch({
        type: GET_TERM_STORE,
        payload: termStoreData
      })

      const fetchRefinerModel = new FetchRefinerModel();
      if (pageConfig && pageConfig.RefinerConfiguration) {
        dispatch({
          type: PAGE_LEVEL_REFINER,
          payload: fetchRefinerModel.getPageLevelFilter(pageConfig.RefinerConfiguration, termStoreData)
        });
      }

    },
    (error) => {
      window.console.log('get error:', error);
      dispatch({
        type: GET_CONFIGURATION_DATA,
        payload: "",
      });
      dispatch({
        type: PAGE_LEVEL_REFINER,
        payload: [],
      });
    }
  );
};
export default initConfigurationData;

